import axios from 'axios';

const pos = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

// ✅ ใส่ token สดทุก request
pos.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

pos.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('pos error:', {
      message: error?.message,
      url: error?.config?.baseURL + error?.config?.url,
      status: error?.response?.status,
    });
    return Promise.reject(error);
  }
);

export default pos;
